module.exports = __webpack_public_path__ + "img/finish.f3d0e835.png";